import React from 'react';

import { AspectRatioOutlined } from '@mui/icons-material';
import { ToggleButton } from '@mui/material';

import createBlockInputSection from './helpers/createBlockInputSection';
import HideSectionInput from './special-inputs/HideSectionInput';

const AvatarSidebarForm = createBlockInputSection({
  title: 'Avatar block',
  inputs: [
    {
      type: 'slider',
      props: {
        label: 'Size',
        name: 'size',
        iconLabel: <AspectRatioOutlined sx={{ color: 'text.secondary' }} />,
        step: 4,
        min: 32,
        max: 256,
        units: 'px',
      },
    },
    {
      type: 'toolbar-toggle',
      props: {
        label: 'Shape',
        name: 'shape',
        children: [
          <ToggleButton key={0} value="circle">
            Circle
          </ToggleButton>,
          <ToggleButton key={1} value="square">
            Square
          </ToggleButton>,
          <ToggleButton key={2} value="rounded">
            Rounded
          </ToggleButton>,
        ],
      },
    },
    {
      type: 'text',
      props: {
        label: 'Image URL',
        placeholder: '{{user.avatarUrl}}',
        name: 'imageUrl',
        helperText: 'Leave blank to use fallback text.',
      },
    },
    {
      type: 'text',
      props: {
        label: 'Fallback text',
        name: 'fallbackText',
        placeholder: '{{user.displayName}}',
        helperText: 'Automatically truncates to 2 characters max.',
      },
    },
    {
      type: 'color',
      props: { label: 'Fallback text background color', name: 'fallbackColor' },
    },
    'textAlign',
    'padding',
    HideSectionInput,
  ],
});

export default AvatarSidebarForm;
